/** Membership roles that belong to DOMIO Cleaning (not Serwis). */
export const CLEANING_STAFF_ROLES = ["cleaner", "staff", "coordinator"] as const;

export type CleaningStaffRole = (typeof CLEANING_STAFF_ROLES)[number];

export function isCleaningStaffRole(role: string | null | undefined): boolean {
  if (!role) return false;
  return (CLEANING_STAFF_ROLES as readonly string[]).includes(role.trim().toLowerCase());
}

/** Active Cleaning memberships only (archived workers are hidden from staff lists). */
export function isActiveMembership(isActive: boolean | null | undefined): boolean {
  return isActive !== false;
}
